import { ConsultaPadrao } from "../../../components/ConsultaPadrao";
import { ExSwitch } from "../../../components/ExSwitch";
import { model_tipo_movimento_arquivo } from "../../../models";

export const TipoMovimentoArquivo = () => {
    const columns = [
        { field: 'tipmovdescricao', header: 'Tipo de Movimento' },
        { field: 'tipmovarqtipo', header: 'Nome do Arquivo' },
        { field: 'tipmovarqpdf', header: 'Aceita PDF', body: (e: any) => <ExSwitch checked={e.tipmovarqpdf === 1} /> },
        { field: 'tipmovarqimagem', header: 'Aceita Imagem' , body: (e: any) => <ExSwitch checked={e.tipmovarqimagem === 1} />},
        { field: 'tipmovarqativo', header: 'Ativo' },
        { field: 'functions', style: { minWidth: '2rem', width: '2rem' } }
    ];

    return (
        <ConsultaPadrao model={model_tipo_movimento_arquivo} columns={columns} sortField="tipmovdescricao" />
    )
}